"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coalesce = void 0;
var deepcopy_1 = __importDefault(require("deepcopy"));
var object_path_1 = __importDefault(require("object-path"));
var remove_nulls_1 = require("./remove-nulls");
/**
 * Wraps objectPath's coalesce to first remove null values in the object before looking for paths, given that nulls are far more common when pulling data from APIs.
 * @param obj - the object to access properties from
 * @param paths - a set of property paths to look for, in priority order
 * @returns
 */
var coalesce = function (obj, paths) {
  return object_path_1.default.coalesce((0, remove_nulls_1.removeNulls)((0, deepcopy_1.default)(obj)), paths);
};
exports.coalesce = coalesce;